import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { getToken } from '../../services/authToken';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function claimDailyTask(taskId) {
  const token = getToken();
  const res = await axios.post(
    `${API}/cabin/daily-tasks/${taskId}/claim`,
    {},
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  return res.data;
}

export function useClaimDailyTask() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: claimDailyTask,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['cabin', 'daily-tasks'] });
      qc.invalidateQueries({ queryKey: ['cabin', 'stats'] });
    },
  });
}
